import {makeVar} from '@apollo/client';

export const languageTranslationVar = makeVar(null);